module.exports = __webpack_public_path__ + "static/media/memories-Text.6c7b5ec0.png";